import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaginationService {
  private currentPageSubject = new BehaviorSubject<number>(1);
  public currentPage$ = this.currentPageSubject.asObservable();

  private userInteractedWithFilters = false;

  public setCurrentPage(page: number): void {
    if (this.currentPageSubject.getValue() === page) {
      return;
    }
    this.currentPageSubject.next(page);
  }

  public getCurrentPage(): number {
    return this.currentPageSubject.getValue();
  }

  public setUserInteractedWithFilters(filterChanged: boolean): void {
    this.userInteractedWithFilters = filterChanged;
  }

  public getUserInteractedWithFilters(): boolean {
    return this.userInteractedWithFilters;
  }
}
